import { useEffect, useRef, useState } from "react";

// useNavegacionLista — navegación con teclado para los desplegables de
// sugerencias (.deplist): ↑/↓ mueven la opción marcada, Intro o Tab la eligen
// y Esc cierra la lista. La opción marcada lleva la clase "sel" y la lista se
// desplaza sola para que siempre se vea.
//
//   const nav = useNavegacionLista(matches, elegir, () => setMatches([]));
//   <input onKeyDown={nav.onKeyDown} ... />
//   <div className="deplist" ref={nav.listaRef}>
//     {matches.map((x, i) => <div {...nav.opcion(i)} onMouseDown={...}>…</div>)}
//   </div>
//
// onKeyDown solo actúa si la lista tiene opciones; si no, no hace nada (y
// devuelve false), para que el campo siga con su comportamiento normal.
export default function useNavegacionLista(items, onElegir, onCerrar) {
  const [sel, setSel] = useState(0);
  const listaRef = useRef(null);

  useEffect(() => { setSel(0); }, [items]);
  useEffect(() => {
    listaRef.current?.children?.[sel]?.scrollIntoView?.({ block: "nearest" });
  }, [sel]);

  const onKeyDown = (e) => {
    const n = items?.length || 0;
    if (!n) return false;
    if (e.key === "ArrowDown") { e.preventDefault(); setSel((s) => (s + 1) % n); return true; }
    if (e.key === "ArrowUp") { e.preventDefault(); setSel((s) => (s - 1 + n) % n); return true; }
    if (e.key === "Enter" || (e.key === "Tab" && !e.shiftKey)) {
      e.preventDefault(); onElegir(items[Math.min(sel, n - 1)]); return true;
    }
    if (e.key === "Escape") { e.preventDefault(); onCerrar?.(); return true; }
    return false;
  };

  const opcion = (i) => ({
    className: `do ${i === sel ? "sel" : ""}`,
    onMouseEnter: () => setSel(i),
  });

  return { sel, setSel, onKeyDown, opcion, listaRef };
}
